import AuthService from '../services/authService';

// The public student inquiry form (built into this app) is only offered to these accounts.
export const STUDENT_FORM_ALLOWED_EMAILS = ['thurairethinam.gopinath@esoft.lk'];
export const STUDENT_FORM_SLUG = 'gopinath';
// inquiry_type stamped by the backend on submissions that come from the public form.
export const STUDENT_FORM_INQUIRY_TYPE = 'Online Form';

export const getStudentFormUrl = () => `${window.location.origin}/inquiry-form/${STUDENT_FORM_SLUG}`;

export function canShareStudentForm() {
    const staff = AuthService.getUser()?.superAdmin?.staff;
    return [staff?.officeEmail, staff?.gmail, staff?.email]
        .filter(Boolean)
        .some((email) => STUDENT_FORM_ALLOWED_EMAILS.includes(String(email).trim().toLowerCase()));
}
